import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/analytics.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "adobe-mobile-library-v4-to-experience-platform-analytics-migration"
    }}>{`Adobe Mobile Library (v4) to Experience Platform Analytics migration`}</h1>
    <h2 {...{
      "id": "configuration"
    }}>{`Configuration`}</h2>
    <p>{`The Adobe Experience Platform Analytics extension uses `}<a parentName="p" {...{
        "href": "https://experience.adobe.com/#/data-collection/"
      }}>{`tags`}</a>{` to configure the Experience Platform SDKs. This replaces the ADBMobileConfig.json which the Mobile Services SDK used for configuration. To get started with the AEP SDKs:`}</p>
    <ol>
      <li parentName="ol">{`Create a mobile property on tags. `}<br />{`See `}<a parentName="li" {...{
          "href": "../../home/getting-started/create-a-mobile-property.md"
        }}>{`Set up a mobile property`}</a>{` for more information.`}</li>
      <li parentName="ol">{`Configure your mobile app with the create mobile property.`}<br />{`The AEP Mobile Core extension provides general functionality required by all the Adobe AEP extensions. The Configuration extension is built into the Mobile Core and contains the configureWithAppId API. This API is used to link the tag mobile property with your mobile app. The documentation for this API can be seen at the `}<a parentName="li" {...{
          "href": "../../home/base/mobile-core/configuration/api-reference.md#configurewithappid"
        }}>{`Configuration API Reference`}</a>{` page. A code sample showing the usage of this API is provided below.`}</li>
      <li parentName="ol">{`Once all the Platform extensions are imported and configured correctly, remove the v4 Mobile SDK dependency. `}<br />{`This step is mandatory and a mix of v4 and AEP API calls is not supported.`}</li>
    </ol>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=config" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=config" mdxType="Tabs" />
    <h2 {...{
      "id": "analytics-migration-overview"
    }}>{`Analytics Migration Overview`}</h2>
    <p>{`For an overview of the API mapping between the Mobile Services SDK and Adobe Experience Platform SDKs, see the `}<a parentName="p" {...{
        "href": "./api-changelog.md"
      }}>{`API Change Log`}</a>{`. This section describes the Analytics-specific changes made with the AEP Analytics extension.`}</p>
    <h3 {...{
      "id": "deprecated-api"
    }}>{`Deprecated API`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`API`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Notes`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackActionFromBackground`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Deprecated`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackLocation:data:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This functionality is available in the `}<a parentName="td" {...{
              "href": "../../solution/places/index.md"
            }}>{`Places extension`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackBeacon:Data:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Support modified. `}<a parentName="td" {...{
              "href": "../../solution/adobe-analytics/track-beacon.md"
            }}>{`See guide`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackingClearCurrentBeacon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Support modified. `}<a parentName="td" {...{
              "href": "../../solution/adobe-analytics/track-beacon.md"
            }}>{`See guide`}</a>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackLifetimeValueIncrease:data:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This functionality can be recreated using the `}<a parentName="td" {...{
              "href": "../../solution/adobe-analytics/index.md"
            }}>{`Analytics`}</a>{` and `}<a parentName="td" {...{
              "href": "../../home/base/profile/index.md"
            }}>{`User Profile`}</a>{` extensions.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackTimedActionStart:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This functionality can be recreated using the `}<a parentName="td" {...{
              "href": "../../solution/adobe-analytics/index.md"
            }}>{`Analytics`}</a>{` and `}<a parentName="td" {...{
              "href": "../../home/base/profile/index.md"
            }}>{`User Profile`}</a>{` extensions.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackTimedActionUpdate:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This functionality can be recreated using the `}<a parentName="td" {...{
              "href": "../../solution/adobe-analytics/index.md"
            }}>{`Analytics`}</a>{` and `}<a parentName="td" {...{
              "href": "../../home/base/profile/index.md"
            }}>{`User Profile`}</a>{` extensions.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackTimedActionEnd:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This functionality can be recreated using the `}<a parentName="td" {...{
              "href": "../../solution/adobe-analytics/index.md"
            }}>{`Analytics`}</a>{` and `}<a parentName="td" {...{
              "href": "../../home/base/profile/index.md"
            }}>{`User Profile`}</a>{` extensions.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`trackTimedActionExists:`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This functionality can be recreated using the `}<a parentName="td" {...{
              "href": "../../solution/adobe-analytics/index.md"
            }}>{`Analytics`}</a>{` and `}<a parentName="td" {...{
              "href": "../../home/base/profile/index.md"
            }}>{`User Profile`}</a>{` extensions.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "experience-platform-extensions-installation-and-setup"
    }}>{`Experience Platform extensions installation and setup`}</h2>
    <h3 {...{
      "id": "register-the-extensions-and-link-the-app-to-the-configuration-created-with-data-collection-tags"
    }}>{`Register the extensions and link the app to the configuration created with Data Collection tags`}</h3>
    <p>{`In your app's Application class add the mobile extension registration and configuration code:`}</p>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=aep-install" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=aep-install" mdxType="Tabs" />
    <p>{`For more details, see `}<a parentName="p" {...{
        "href": "../../solution/adobe-analytics/index.md#add-analytics-to-your-application"
      }}>{`Add Analytics to your application`}</a>{`.`}</p>
    <h2 {...{
      "id": "api-changes"
    }}>{`API changes`}</h2>
    <h3 {...{
      "id": "track-app-states-and-actions"
    }}>{`Track app states and actions`}</h3>
    <h4 {...{
      "id": "adobe-mobile-library-v4"
    }}>{`Adobe Mobile Library (v4)`}</h4>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=api-changes-v4" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=api-changes-v4" mdxType="Tabs" />
    <h4 {...{
      "id": "experience-platform-mobile-sdks"
    }}>{`Experience Platform Mobile SDKs`}</h4>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=api-changes-aep" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=api-changes-aep" mdxType="Tabs" />
    <h2 {...{
      "id": "privacy-status-changes-in-the-experience-platform-sdk"
    }}>{`Privacy status changes in the Experience Platform SDK`}</h2>
    <p>{`The privacy APIs `}<inlineCode parentName="p">{`setPrivacyStatus`}</inlineCode>{` and `}<inlineCode parentName="p">{`getPrivacyStatus`}</inlineCode>{` can be found in the Mobile Core. Similar to the v4 SDK, the Analytics extension will follow these behaviors depending on the privacy status set:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Opted in:`}</strong>{` Analytics hits will be sent.`}</li>
      <li parentName="ul"><strong parentName="li">{`Unknown:`}</strong>{` Analytics hits will be queued.`}</li>
      <li parentName="ul"><strong parentName="li">{`Opted out:`}</strong>{` Analytics hits will be dropped.`}</li>
    </ul>
    <h3 {...{
      "id": "experience-platform-mobile-sdks-1"
    }}>{`Experience Platform Mobile SDKs`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="2" mdxType="TabsBlock" />
    <p>{`Android`}</p>
    <Tabs query="platform=android&task=privacy-changes-aep" mdxType="Tabs" />
    <p>{`iOS`}</p>
    <Tabs query="platform=ios&task=privacy-changes-aep" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      